import React from 'react';
import Button from '../Button/Button';
import FontsDefault from '../../Assistant/DefaultStyle';
import { DefaultFlex, DefaultFlexCenter } from '../../Assistant/DefaultStyle';

function AboutContact() {
  return (
    <div className={`bg-gray700 h-48 ${DefaultFlexCenter}`}>
      <div
        className={`md:${DefaultFlex} items-center mx-auto p-4 md:w-9/12 w-full text-center`}
      >
        <div className=''>
          <h1
            className={`${FontsDefault.text2xl} md:w-10/12 w-full font-bold text-textColor`}
          >
            جاهزون لإنجاز خدمتك بأسرع وقت وأفضل جودة مع فريق من المتخصصين ذوي
            الخبرات وأصحاب الشهادات العليا .
          </h1>
        </div>

        <div className='mt-4'>
          <Button title='تواصل معنا الان' />
        </div>
      </div>
    </div>
  );
}

export default AboutContact;
